export default class TariffProduct {
  data = null;

  constructor (data) {
    this.data = data;
  }

  get id () {
    return this.data.id;
  }

  get code () {
    return this.data.code;
  }

  get name () {
    return this.data.name;
  }

  get priority () {
    return this.data.priority;
  }

  get shc () {
    return this.data.usingSHC;
  }

  get fullName () {
    return `${this.code} | ${this.name}`;
  }
};
